import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Inset from 'syf-component-library/ui/spacing/Inset';
import AuthorizedUsersPrivileges from './utils/AuthorizedUsersPrivileges';
import AuthorizedUsersForm from './utils/AuthorizedUserForm';
import { ContentWrapper } from './utils/subcomponents';
const AddAuthorizedUsers = ({ authorizedUserInputValuesState, handleBlur, updateState, isAddAuthUserSubmitted }) => {
    return (_jsxs(ContentWrapper, { children: [_jsx(AuthorizedUsersPrivileges, {}), _jsx(Inset, { horizontal: "xxlarge", children: _jsx(AuthorizedUsersForm, { ...{
                        authorizedUserInputValuesState,
                        handleBlur,
                        updateState,
                        isAddAuthUserSubmitted
                    } }) })] }));
};
export default AddAuthorizedUsers;
